import React from 'react';

// Main LVLMANIA Landing Page Component
const HomePage = () => {
    return (
        <div className="min-h-screen bg-gray-900 text-gray-100 antialiased">
            {/* Hero Section */}
            <section className="relative bg-gradient-to-br from-indigo-900 to-purple-900 py-20 md:py-32 px-6 overflow-hidden rounded-b-3xl shadow-2xl">
                {/* Abstract background shapes for a dynamic look */}
                <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
                    <div className="absolute w-64 h-64 bg-purple-500 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob top-10 left-10"></div>
                    <div className="absolute w-64 h-64 bg-indigo-500 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-2000 top-20 right-20"></div>
                    <div className="absolute w-64 h-64 bg-pink-500 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-4000 bottom-10 left-1/4"></div>
                </div>

                <div className="relative z-10 max-w-5xl mx-auto text-center">
                    <h1 className="text-5xl md:text-7xl font-extrabold leading-tight mb-6 bg-clip-text text-transparent bg-gradient-to-r from-purple-300 via-indigo-300 to-pink-300 drop-shadow-lg">
                        Unleash Your Inner Gamer
                    </h1>
                    <p className="text-lg md:text-xl text-gray-200 mb-10 max-w-2xl mx-auto">
                        Dive into an endless universe of thrilling games, connect with fellow players, and conquer new challenges. LVLMANIA is your ultimate gaming destination.
                    </p>
                    <div className="flex flex-col sm:flex-row justify-center gap-4">
                        <button
                            className="bg-violet-700 hover:bg-gray-600 text-gray-200 font-bold py-3 px-8 rounded-full shadow-lg transition duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-gray-500 focus:ring-opacity-50"
                            onClick={() => {
                                const featuredGamesSection = document.querySelector('.py-16');
                                if (featuredGamesSection) {
                                    featuredGamesSection.scrollIntoView({ behavior: 'smooth' });
                                }
                            }}
                        >
                            Explore Games
                        </button>
                    </div>
                </div>
            </section>

            {/* Featured Games Section */}
            <section className="py-16 md:py-24 px-6 max-w-7xl mx-auto">
                <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 text-purple-400 drop-shadow-md">
                    Featured Games
                </h2>

                <div className="flex flex-wrap justify-center gap-8">
                    {/* Game Card 1 */}
                    <div className="max-w-xs bg-gray-800 rounded-2xl shadow-xl overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-2xl border border-gray-700">
                        <img src="https://placehold.co/600x350/6B46C1/ffffff?text=Bunny+Escape" alt="Bunny Escape Game" className="w-full h-48 object-cover rounded-t-xl" />
                        <div className="p-6">
                            <h3 className="text-2xl font-bold text-white mb-2">Bunny Escape</h3>
                            <p className="text-gray-400 text-base mb-4">
                                "Bunny Escape is a thrilling puzzle game where you guide a bunny through a maze, avoiding monsters and reaching the exit safely. Strategize your moves and outsmart the monsters to win!"
                            </p>
                            <button
                                className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-300 transform hover:scale-100 focus:outline-none focus:ring-2 focus:ring-purple-500"
                                onClick={() => {
                                    window.location.href = '/bunny-escape';
                                }}
                            >
                                Play Now
                            </button>
                        </div>
                    </div>

                    {/* Game Card 2 */}
                    <div className="max-w-xs bg-gray-800 rounded-2xl shadow-xl overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-2xl border border-gray-700">
                        <img src="https://placehold.co/600x350/4C51BF/ffffff?text=2357+Prime" alt="2357 Prime Game" className="w-full h-48 object-cover rounded-t-xl" />
                        <div className="p-6">
                            <h3 className="text-2xl font-bold text-white mb-2">2357 Prime</h3>
                            <p className="text-gray-400 text-base mb-4">
                                "2357 Prime Quest: Merge tiles strategically to form prime numbers and reach the ultimate target of 2357 in this brain-teasing game!"
                            </p>
                            <button
                                className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-300 transform hover:scale-100 focus:outline-none focus:ring-2 focus:ring-purple-500"
                                onClick={() => {
                                    window.location.href = '/2357-prime';
                                }}
                            >
                                Play Now
                            </button>
                        </div>
                    </div>

                    {/* Prime Path Mobile App Card */}
                    <div className="max-w-xs bg-gray-800 rounded-2xl shadow-xl overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-2xl border border-gray-700">
                        <img src="https://placehold.co/600x350/059669/ffffff?text=Prime+Path+Mobile" alt="Prime Path Mobile App" className="w-full h-48 object-cover rounded-t-xl" />
                        <div className="p-6">
                            <h3 className="text-2xl font-bold text-white mb-2">Prime Path Mobile</h3>
                            <p className="text-gray-400 text-base mb-4">
                                "Download the mobile version of Prime Path! Features touch controls, achievements, and optimized gameplay for your phone."
                            </p>
                            <div className="space-y-2">
                                <button
                                    className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-300 transform hover:scale-100 focus:outline-none focus:ring-2 focus:ring-green-500"
                                    onClick={() => {
                                        window.location.href = '/prime-path';
                                    }}
                                >
                                    Learn More
                                </button>
                                <button
                                    className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-300 transform hover:scale-100 focus:outline-none focus:ring-2 focus:ring-purple-500"
                                    onClick={() => {
                                        window.location.href = '/2357-prime';
                                    }}
                                >
                                    Try Web Demo
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="text-center mt-16">
                    <button
                        className="inline-block bg-gray-700 hover:bg-gray-600 text-gray-200 font-bold py-3 px-8 rounded-full shadow-lg transition duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-gray-500 focus:ring-opacity-50"
                        onClick={() => {
                            const featuredGamesSection = document.querySelector('.py-16');
                            if (featuredGamesSection) {
                                featuredGamesSection.scrollIntoView({ behavior: 'smooth' });
                            }
                        }}
                    >
                        View All Games
                    </button>
                </div>
            </section>

            {/* Call to Action / Community Section */}
            <section className="bg-gray-800 py-16 md:py-24 px-6 rounded-t-3xl shadow-2xl">
                <div className="max-w-4xl mx-auto text-center">
                    <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-6">Join Our Thriving Community</h2>
                    <p className="text-lg md:text-xl text-gray-300 mb-10">
                        Connect with millions of gamers worldwide. Share tips, compete in tournaments, and make new friends.
                    </p>
                    {/* <div className="flex flex-col sm:flex-row justify-center items-center gap-4 max-w-lg mx-auto">
                        <input
                            type="email"
                            placeholder="Enter your email address"
                            className="w-full sm:flex-grow p-3 rounded-xl bg-gray-700 text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-purple-500 placeholder-gray-400 transition duration-300"
                        />
                        <button className="w-full sm:w-auto bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transition duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-purple-500 focus:ring-opacity-50">
                            Subscribe for Updates
                        </button>
                    </div> */}

                    <div className="text-center">
                        <p className="text-lg text-gray-300 mb-4">
                            Have feedback or want to connect? Reach out to us at:
                        </p>
                        <a
                            href="mailto:support@lvlmania.com"
                            className="text-purple-400 hover:text-purple-500 font-bold text-lg transition duration-300"
                        >
                            support@lvlmania.com
                        </a>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default HomePage;
